import { useState, useEffect } from "react";
import "./QuestionSettingsPhone.css";
import { QuestionSelector } from "../question-selector/QuestionSelector";
import { Question, QuestionType, UpdateQuestionPayload } from "effno-core";
import { apiUpdateQuestion } from "../../services/QuestionService";
import toast from "react-hot-toast";
import { toastFail } from "../../config";
import { FormCountryCodes } from "../form-widgets/FormCountryCodes";
import { CountrySelect, en } from "../form-widgets/CountrySelect";
import { MySwitch } from "../form-widgets/MySwitch";

type QuestionSettingsPhoneProps = {
    question: Question;
    onChange: (question: Question) => void;
}

export const QuestionSettingsPhone = ({question, onChange} : QuestionSettingsPhoneProps) => {

    const [settings, setSettings] = useState<any | null>(JSON.parse(question.settings));
    const [type, setType] = useState<QuestionType>(question.type);
    const [required, setRequired] = useState<boolean>(question.required);

    useEffect(() => {
        setSettings(JSON.parse(question.settings));
        setRequired(question.required);
        setType(question.type);
    }, [question]);

    const handleTypeChange = async (value: string) => {
        console.log("[QuestionSettingsPhone/handleTypeChange] value: ", value);
    }

    const handleRequiredChange = async (checked: boolean) => {
        setRequired(checked);

        const payload: UpdateQuestionPayload = {
            questionId: question.id,
            type,
            title: question.title,
            description: question.description,
            required: checked,
            settings: JSON.stringify(settings),
            conditions: question.conditions
        }

        updateSettings(payload);
    }

    // const handleSettingChange = async (e: any) => {
    //     console.log("[QuestionSettingsPhone/handleSettingChange] e: ", e);

    //     let newSettings = {...settings};

    //     switch (e.target.name) {
    //         case "defaultCountryCode":
    //             newSettings = {...settings, defaultCountryCode: e.target.value};
    //             break;
    //         default:
    //             newSettings = {...settings, [e.target.name]: e.target.value};
    //     }

    //     setSettings(newSettings);

    //     const payload: UpdateQuestionPayload = {
    //         questionId: question.id,
    //         type,
    //         title: question.title,
    //         description: question.description,
    //         required,
    //         settings: JSON.stringify(newSettings),
    //         conditions: question.conditions
    //     }

    //     updateSettings(payload)
    // }

    const handleDefaultCountryCodeChange = async (value: string) => {
        console.log("[QuestionSettingsPhone/handleDefaultCountryCodeChange] value: ", value);

        const newSettings = {...settings, defaultCountryCode: value};

        setSettings(newSettings);

        const payload: UpdateQuestionPayload = {
            questionId: question.id,
            type,
            title: question.title,
            description: question.description,
            required,
            settings: JSON.stringify(newSettings),
            conditions: question.conditions
        }

        updateSettings(payload);
    }

    // have to send in the payload here due to react setting asyncs
    const updateSettings = async(payload: UpdateQuestionPayload) => {

        const newQuestion = await apiUpdateQuestion(payload);

        if (!newQuestion) {
            toast("Error updating question", toastFail);
            return;
        }

        // update UI
        onChange(newQuestion);
    }

    console.log("[QuestionSettingsPhone] settings: ", settings);

    return (        
        <>
            <div className="question-settings-phone">
                {/* <QuestionSelector defaultValue={type} onChange={handleTypeChange}/>

                <div className="question-setting-divider">{}</div> */}

                <div className="question-setting">
                    <div className="question-setting-label">
                        Required
                    </div>
                    <div className="question-setting-checkbox">
                        <MySwitch 
                            id="required"
                            checked={required}
                            onChange={handleRequiredChange}
                        />
                    </div>
                </div>

                <div className="question-setting-stack">
                    <div className="question-setting-stack-top">
                        <div className="question-setting-label">
                            Default Country
                        </div>
                       
                    </div>
                        
                    <div className="question-setting-select">
                        <CountrySelect
                            labels={en}
                            value={settings?.defaultCountryCode}
                            onChange={handleDefaultCountryCodeChange}
                            data-testid="defaultCountryCode"
                            // onChange={setCountry}
                        />
                    </div>
                </div>
            </div>
            
        </>
    )
}